import React, { useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Outlet, useLocation } from "react-router-dom";

import "@css/pages/leagues.scss";

import { scrollToTop } from "@lib/utils";

import Sidebar from "@Leagues/components/Sidebar";

const LeaguesLayout = (): React.JSX.Element => {
    const location = useLocation();
    const leaguesPathMatch = /leagues/.test(location.pathname);
    const playoffsPathMatch = /playoffs/.test(location.pathname);

    useEffect(() => {
        scrollToTop();
    }, [location.pathname]);

    return (
        <Container
            className="py-2 py-lg-5 leagues"
            data-testid="leaguesContent"
        >
            {leaguesPathMatch ? (
                <Row>
                    <Col
                        xl={playoffsPathMatch ? 2 : undefined}
                        lg={!playoffsPathMatch ? 2 : undefined}
                    >
                        <Sidebar />
                    </Col>
                    <Col>
                        <Outlet />
                    </Col>
                </Row>
            ) : (
                <Row>
                    <Col>
                        <Outlet />
                    </Col>
                </Row>
            )}
        </Container>
    );
};

export default LeaguesLayout;
